import { UploadFile } from 'ngx-uploader';

type ReadAsStringCallback = (data: string) => void;

export class ApplicationFile {

    file: UploadFile;
    supportedFileType: string[];
    maxFileSize: number;

    constructor(file: UploadFile, supportedFileType: string[], maxFileSize: number) {
        this.file = file;
        this.supportedFileType = supportedFileType;
        this.maxFileSize = maxFileSize;
    }

    public isValid(): boolean {
        return this.isValidFormat() && this.isValidSize();
    }

    public isValidFormat(): boolean {
        if (this.file == null) {
            return true;
        }
        if (this.supportedFileType == null) {
            return true;
        }
        if (this.supportedFileType.indexOf(this.file.type) == -1) {
            return false;
        } else {
            return true;
        }
    }

    public isValidSize(): boolean {
        if (this.file == null) {
            return true;
        }
        if (this.file.size > this.maxFileSize) {
            return false;
        } else {
            return true;
        }
    }

    public readAsDataURL(callback: ReadAsStringCallback) {
        var reader = new FileReader();

        if (this.file != null) {
            let nativeFile = <Blob>this.file.nativeFile;

            reader.onload = (function (theFile) {
                return function (e) {
                    callback(e.target.result);
                };
            })(nativeFile);

            reader.readAsDataURL(nativeFile);
        } else {
            callback(null);
        }
    }

    public readAsBase64(callback: ReadAsStringCallback) {
        var reader = new FileReader();

        if (this.file != null) {
            let nativeFile = <Blob>this.file.nativeFile;

            reader.onload = (function (theFile) {
                return function (e) {
                    callback((e.target.result).split(",")[1]);
                };
            })(nativeFile);

            reader.readAsDataURL(nativeFile);
        } else {
            callback(null);
        }

    }
}
